import { createPortal } from 'react-dom';
import { confirmAsync } from '../utils/confirm';

/**
 * Custom styled onay popup — window.confirm() yerine kullanılır.
 * 
 * Kullanım:
 *   <OnayPopup
 *     acik={showPopup}
 *     baslik="Silme Onayı"
 *     mesaj="Bu kaydı silmek istediğinize emin misiniz?"
 *     onEvet={() => { handleSil(); setShowPopup(false); }}
 *     onHayir={() => setShowPopup(false)}
 *   />
 */
export default function OnayPopup({ acik, baslik, mesaj, onEvet, onHayir, evetText = 'EVET, SİL', hayirText = 'VAZGEÇ', tehlikeli = true }) {
  if (!acik) return null;
  return createPortal(
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-md z-[9999] flex items-center justify-center p-4 animate-fade-in" onClick={onHayir}>
      <div className="bg-white rounded-[2.5rem] shadow-2xl border border-white/20 max-w-md w-full overflow-hidden animate-modal-in" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className={`px-8 py-7 ${tehlikeli ? 'bg-gradient-to-r from-rose-500 to-red-600' : 'bg-gradient-to-r from-blue-500 to-indigo-600'}`}>
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center text-2xl shadow-inner border border-white/30">
              {tehlikeli ? '⚠️' : 'ℹ️'}
            </div>
            <div>
              <h3 className="text-lg font-black text-white tracking-tight">{baslik || 'Onay'}</h3>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="px-8 py-8">
          <p className="text-sm font-bold text-gray-600 leading-relaxed">{mesaj}</p>
        </div>

        {/* Footer */}
        <div className="px-8 py-5 bg-gray-50/50 border-t border-gray-100 flex items-center justify-end gap-3">
          <button onClick={onHayir}
            className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">
            {hayirText}
          </button>
          <button onClick={onEvet}
            className={`px-10 py-3.5 rounded-2xl text-xs font-black text-white shadow-xl transition-all hover:-translate-y-0.5 active:translate-y-0 uppercase tracking-widest ${
              tehlikeli
                ? 'bg-gradient-to-r from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700 shadow-rose-200'
                : 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 shadow-blue-200'
            }`}>
            {evetText}
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-fade-in { animation: fade-in 0.2s ease-out forwards; }
        @keyframes modal-in { from { opacity: 0; transform: scale(0.95) translateY(10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        .animate-modal-in { animation: modal-in 0.3s ease-out forwards; }
      `}</style>
    </div>,
    document.body
  );
}
